<template>
    <div>
        <div class="section-heading operations">
            <div class="container">
                <h1 class="section-heading__title">Operaciones</h1>
                <div class="section-heading__actions">
                    <button
                        class="btn btn-secondary"
                        @click="$router.push('operations-history')"
                    >
                        Historial de Operaciones
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div>
                <operation-list
                    :operations="operations"
                    :totalPages="totalPages"
                    @get-list-op="getOperations"
                    ref="opList"
                ></operation-list>
            </div>
        </div>
    </div>
</template>

<script>
import OperationList from "@/components/OperationList.vue";
import { mapState } from "vuex";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

axios.defaults.headers.common["referer-id"] =
    new Date().toLocaleString().replace(/[^\d]/g, "") +
    parseInt(Math.random() * 100000);

const listOperations = gql`
    query listOperations(
        $currentUserToken: String!
        $page: Int
        $sortBy: String
        $orderBy: Int
        $filters: OperationsFilterInput
    ) {
        listOperations(
            currentUserToken: $currentUserToken
            page: $page
            sortBy: $sortBy
            orderBy: $orderBy
            filters: $filters
        ) {
            totalPages
            operations {
                activityId
                buyer {
                    organization {
                        id
                    }
                }
                createdAt
                offerType
                parentOfferId
                price
                pdfUrl
                quantity
                securePayment {
                    lapse
                    id
                    percentage
                    stage
                }
                state
                objectType
                negotiation {
                    state
                    responder
                }
                offer {
                    id
                    alreadyPublishedInMuvin
                    negotiations {
                        id
                    }
                }
                destination {
                    name
                    organization {
                        id
                    }
                }
                part {
                    opener {
                        organizationId
                        id
                    }
                }

                buyerOperator {
                    organizationId
                }
                sellerOperator {
                    organizationId
                }
                origin {
                    name
                    organization {
                        id
                        
                    }
                }
            }
        }
    }
`;

export default {
    components: {
        "operation-list": OperationList,
    },
    data() {
        return {
            operations: [],
            totalPages: 1,
        };
    },
    computed: {
        ...mapState({
            offerId: (state) => state.Offer.offerInSidebar,
            currentUser: (state) => state.User.currentUser,
        }),
    },
    beforeMount() {
        this.getOperations();
    },
    methods: {
        getOperations(pagination = 1) {
            var variables = {
                currentUserToken: localStorage.getItem("USER_TOKEN"),
                page: pagination,
                filters: {},
            };
            if (this.$refs.opList) {
                Object.assign(variables, {
                    sortBy: this.$refs.opList.sortBy,
                    orderBy: this.$refs.opList.orderBy,
                });
                if (this.$refs.opList.$refs.filters.securePaymentFilter) {
                    if (this.$refs.opList.$refs.filters.securePaymentStage) {
                        variables.filters.securePayment = {
                            stage: this.$refs.opList.$refs.filters
                                .securePaymentStage,
                        };
                    } else {
                        variables.filters.securePayment = { stage: "all" };
                    }
                }
            }
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(listOperations),
                        variables: variables,
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.operations =
                            res.data.data.listOperations.operations;
                        this.totalPages = Number(
                            res.data.data.listOperations.totalPages
                        );
                    } else {
                        console.log(res.data.errors);
                    }
                });
        },
        getFilteredData() {
            var filters = this.$refs.filtersComponent.filters;
            var week = this.$refs.filtersComponent.week;
            this.filteredData = this.operations;
            if (week) {
                this.filteredData = this.filteredData.filter((ops) =>
                    week.includes(ops.week)
                );
            }
            if (filters.type) {
                this.filteredData = this.filteredData.filter(
                    (ops) => ops.offerType.split("_")[1] === filters.type
                );
            }
            if (filters.subtype) {
                this.filteredData = this.filteredData.filter(
                    (ops) => ops.offerType.split("_")[0] === filters.subtype
                );
            }
        },
    },
};
</script>
